import { render } from "./FileRegisterForm.vue?vue&type=template&id=7b9d7165&scoped=true"
import script from "./FileRegisterForm.vue?vue&type=script&lang=js"
export * from "./FileRegisterForm.vue?vue&type=script&lang=js"

import "./FileRegisterForm.vue?vue&type=style&index=0&id=7b9d7165&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b9d7165"

export default script